angular.module('impactx.rfxsupplier').component('ixRfxSupplierTerms', {
        bindings: {
            isClosed: '<',
            trns: '<',
            termsText: '<',
            termsAttachments: '<'
        },
        controller: 'RFXSupplierTermsComponentCtrl',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-terms-component.html'
    }
);